export const comments = [
  {
    id: "comment1",
    name: "예린",
    userId: "피자스쿨개발자",
    userComment: "피자 먹을때 최고!!",
    date: "6일전(수정됨)",
  },
  {
    id: "comment2",
    name: "지훈",
    userId: "티빙개발자",
    userComment: "티빙 보면서 이 노래 들으면 진짜 십쏘네",
    date: "4일전",
  },
  {
    id: "comment3",
    name: "연서",
    userId: "스테이폴리오개발자",
    userComment: "놀러 갈 때 딱이에요!!",
    date: "7시간 전(수정됨)",
  },
  {
    id: "comment4",
    name: "찬영",
    userId: "슈포티파이디자이너",
    userComment: "콜팝 먹으면서 들으니깐 개꿀~",
    date: "2시간 전(수정됨)",
  },
];
